import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { addtodo } from './action';
import TodoListMain from './TodoListMain';

const TodoForm = () => {
    const dispatch=useDispatch();
    const [todoTitle,setTodoTitle]=useState("");
    const handleTodo=(e)=>{
        if(todoTitle.trim()){
          const newTodo=  {
                title:todoTitle
            }
            dispatch(addtodo(newTodo))
            setTodoTitle("")
        }
    }
  return (
    <div className='container mt-5'>
        <h1 className='text-primary text-center'>TO-DO LIST USING REDUX REACT</h1>
    <div className='input-group'>
        <input type="text" name="" id="" className='form-control' value={todoTitle} onChange={(e)=>setTodoTitle(e.target.value)}/>
        <button className='btn btn-primary' onClick={()=>handleTodo()}>ADD</button>
    </div>
    <TodoListMain/>
    </div>
  )
}

export default TodoForm